export default __webpack_public_path__ + "static/media/pratlogo.bb9082ef.png";